import { NumberInput } from '@mantine/core'
import classes from './InputBase.module.css'

export const NumberInputThemeKobo = NumberInput.extend({
  classNames: classes,
})
